class ListShowMore {
    constructor(listClass, maxVisibleItems = 1) {
        this.listClass = listClass;
        this.maxVisibleItems = maxVisibleItems;
        this.initializeLists();
    }

    initializeLists() {
        const lists = document.querySelectorAll(`.${this.listClass}`);
        lists.forEach(list => this.setupList(list));
    }

    setupList(list) {
        const listItems = Array.from(list.querySelectorAll('li'));
        if (listItems.length <= this.maxVisibleItems) return;

        const wrapper = this.createWrapper(list);

        const itemHeight = listItems[0].offsetHeight;
        const initialHeight = itemHeight * this.maxVisibleItems;
        const fadeHeight = 160;
        wrapper.style.height = `${initialHeight + fadeHeight}px`;

        const toggleButton = this.createToggleButton();
        wrapper.insertAdjacentElement('afterend', toggleButton);

        toggleButton.addEventListener('click', () => this.toggleContent(wrapper, toggleButton, list));
    }

    createWrapper(list) {
        const wrapper = document.createElement('div');
        wrapper.className = 'list-show-more-wrapper';

        list.parentNode.insertBefore(wrapper, list);
        wrapper.appendChild(list);

        return wrapper;
    }

    createToggleButton() {
        const button = document.createElement('button');
        button.textContent = 'Show More';
        button.className = 'toggle-more-less';
        return button;
    }

    toggleContent(wrapper, button, list) {
        const isExpanded = wrapper.classList.contains('expanded');
        const fadeHeight = 160;

        if (isExpanded) {
            const itemHeight = list.querySelector('li').offsetHeight;
            const initialHeight = itemHeight * this.maxVisibleItems;
            wrapper.style.height = `${initialHeight + fadeHeight}px`;
        } else {
            wrapper.style.height = `${list.scrollHeight}px`;
        }

        wrapper.classList.toggle('expanded');
        button.textContent = isExpanded ? 'Show More' : 'Show Less';
    }
}

document.addEventListener('DOMContentLoaded', () => new ListShowMore('is-style-split-hide-show-more', 1));
document.addEventListener('DOMContentLoaded', () => new ListShowMore('is-style-split-hide-show-more-2-columns', 1));
